import { IValidationMessage } from '../../../models/validation-message.interface';

const monthValidationMessageList: IValidationMessage[] = [
    {
        error: 'required',
        message: 'Пожалуйста, заполните месяц окончания срока действия карты'
    },
    {
        error: 'incorrectCardExpireMonth',
        message: 'Пожалуйста, заполните месяц окончания срока действия карты корректно'
    },
    {
        error: 'mask',
        message: 'Пожалуйста, заполните месяц окончания срока действия карты корректно'
    }
];

export default monthValidationMessageList;
